export default "__VITE_ASSET__xdNxCXZd__"